<template>
  <div class="register-container">
    <div class="register-box">
      <h1 class="register-title">申请入驻</h1>

      <el-form
          ref="applicationForm"
          :model="applicationForm"
          :rules="applicationRules"
          class="register-form"
          @keyup.enter.native="handleSubmit"
      >
        <el-form-item prop="organizationsName">
          <el-input
              v-model="applicationForm.organizationsName"
              placeholder="请输入机构/组织名称"
              prefix-icon="el-icon-office-building"
          ></el-input>
        </el-form-item>

        <el-form-item prop="picName">
          <el-input
              v-model="applicationForm.picName"
              placeholder="请输入负责人姓名"
              prefix-icon="el-icon-user"
          ></el-input>
        </el-form-item>

        <el-form-item prop="phone">
          <el-input
              v-model="applicationForm.phone"
              placeholder="请输入联系电话"
              prefix-icon="el-icon-phone-outline"
              @blur="handlePhoneBlur"
          >
            <template #append>
              <el-button
                  :disabled="!isPhoneValid || countdown > 0"
                  @click="sendSmsCode"
              >
                {{ countdown > 0 ? `${countdown}秒后重试` : '获取验证码' }}
              </el-button>
            </template>
          </el-input>
        </el-form-item>

        <el-form-item prop="smsCode">
          <el-input
              v-model="applicationForm.smsCode"
              placeholder="请输入短信验证码"
              prefix-icon="el-icon-message"
          ></el-input>
        </el-form-item>

        <el-form-item prop="email">
          <el-input
              v-model="applicationForm.email"
              placeholder="请输入邮箱"
              prefix-icon="el-icon-message"
          ></el-input>
        </el-form-item>

        <el-form-item prop="address">
          <el-input
              v-model="applicationForm.address"
              placeholder="请输入机构地址"
              prefix-icon="el-icon-location-outline"
          ></el-input>
        </el-form-item>

        <el-form-item prop="description">
          <el-input
              v-model="applicationForm.description"
              type="textarea"
              :rows="3"
              placeholder="请简要描述您的机构/组织"
              maxlength="200"
              show-word-limit
          ></el-input>
        </el-form-item>

        <el-form-item prop="agreed">
          <el-checkbox v-model="applicationForm.agreed">
            我已阅读并同意
            <el-link type="primary" @click="showAgreementDialog">《隐私协议及入驻条款》</el-link>
          </el-checkbox>
        </el-form-item>

        <el-form-item>
          <el-button
              type="primary"
              class="register-btn"
              :loading="loading"
              @click="handleSubmit"
          >
            提交申请
          </el-button>
        </el-form-item>
      </el-form>

      <div class="register-footer">
        <span>提交后我们将尽快审核您的申请</span>
      </div>
    </div>

    <!-- 隐私协议及入驻条款弹窗 -->
    <el-dialog
        :title="agreementDialog.title"
        :visible.sync="agreementDialog.visible"
        width="70%"
        top="5vh"
        custom-class="agreement-dialog"
    >
      <div class="agreement-content" v-html="agreementDialog.content"></div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="confirmAgreement">我已阅读并同意</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'OrganizationRegister',
  data() {
    const validatePhone = (rule, value, callback) => {
      if (!/^1[3-9]\d{9}$/.test(value)) {
        callback(new Error('请输入正确的手机号码'))
      } else {
        callback()
      }
    }

    const validateAgreement = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请阅读并同意隐私协议及入驻条款'))
      } else {
        callback()
      }
    }

    return {
      applicationForm: {
        organizationsName: 'fgasdgasdg',
        picName: 'sa',
        phone: '13298350359',
        smsCode: '123456',
        email: 'q@example.com',
        address: 'gasdgasdgasdgasdg',
        description: 'gdsgasdgasdgsdgdas',
        agree:false
      },
      applicationRules: {
        organizationsName: [
          {required: true, message: '请输入机构名称', trigger: 'blur'},
          {min: 2, max: 50, message: '长度在2到50个字符', trigger: 'blur'}
        ],
        picName: [
          {required: true, message: '请输入负责人姓名', trigger: 'blur'},
          {min: 2, max: 20, message: '长度在2到20个字符', trigger: 'blur'}
        ],
        phone: [
          {required: true, message: '请输入联系电话', trigger: 'blur'},
          {validator: validatePhone, trigger: 'blur'}
        ],
        smsCode: [
          {required: true, message: '请输入验证码', trigger: 'blur'},
          {len: 6, message: '验证码为6位数字', trigger: 'blur'}
        ],
        email: [
          {required: true, message: '请输入邮箱地址', trigger: 'blur'},
          {type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur', 'change']}
        ],
        address: [
          {required: true, message: '请输入机构地址', trigger: 'blur'},
          {min: 5, max: 100, message: '长度在5到100个字符', trigger: 'blur'}
        ],
        description: [
          {required: true, message: '请输入机构描述', trigger: 'blur'},
          {min: 10, max: 200, message: '长度在10到200个字符', trigger: 'blur'}
        ],
        agreed: [
          {validator: validateAgreement, trigger: 'change'}
        ]
      },
      loading: false,
      countdown: 0,
      countdownTimer: null,
      isPhoneValid: false,
      agreementDialog: {
        visible: false,
        title: '隐私协议及入驻条款',
        content: `
          <h3>隐私协议</h3>
          <p>1. 我们承诺保护您的个人信息安全，仅将您提供的信息用于入驻审核及相关服务。</p>
          <p>2. 我们不会将您的信息出售或泄露给第三方，除非获得您的授权或法律要求。</p>
          <p>3. 您可以随时联系我们查询、修改或删除您的个人信息。</p>
          <p>4. 我们可能会使用Cookies等技术来改善用户体验，您可以选择禁用。</p>

          <h3>入驻条款</h3>
          <p>1. 您保证提供的所有信息真实、准确、完整，不存在虚假或误导性陈述。</p>
          <p>2. 我们将在收到申请后1-3个工作日内完成审核，并通过邮件或短信通知您结果。</p>
          <p>3. 我们保留拒绝任何入驻申请的权利，且无需说明理由。</p>
          <p>4. 入驻成功后，您应遵守平台相关规则和政策。</p>
          <p>5. 您不得利用平台从事任何违法或侵犯他人权益的活动。</p>
          <p>6. 我们有权根据实际情况调整入驻政策和条款，并通过适当方式通知您。</p>
        `
      }
    }
  },
  beforeDestroy() {
    if (this.countdownTimer) {
      clearInterval(this.countdownTimer)
    }
  },
  methods: {
    handlePhoneBlur() {
      this.isPhoneValid = /^1[3-9]\d{9}$/.test(this.applicationForm.phone)
    },
    sendSmsCode() {
      if (!this.isPhoneValid) return

      this.loading = true
      this.$axios.post('/api/sms/send', {
        phone: this.applicationForm.phone,
        type: 'organization_register'
      }).then(() => {
        this.$message.success('验证码发送成功')
        this.startCountdown()
      }).catch(error => {
        this.$message.error(error.response?.data?.message || '验证码发送失败')
      }).finally(() => {
        this.loading = false
      })
    },
    startCountdown() {
      this.countdown = 60
      this.countdownTimer = setInterval(() => {
        if (this.countdown <= 0) {
          clearInterval(this.countdownTimer)
          return
        }
        this.countdown--
      }, 1000)
    },
    showAgreementDialog() {
      this.agreementDialog.visible = true
    },
    confirmAgreement() {
      this.applicationForm.agreed = true
      this.agreementDialog.visible = false
    },
    handleSubmit() {
      this.$refs.applicationForm.validate(valid => {
        if (valid) {
          this.loading = true
          this.$api.auth.applyOrganization(this.applicationForm)
              .then(response => {
                console.log(response)
                if (response.statusCode === 100200) {
                  this.$message.success('申请提交成功，请等待审核')
                  this.$router.push('/login')
                }
              })
              .catch(() => {

              })
              .finally(() => {
                this.loading = false
              })
        }
      })
    }
  }
}
</script>

<style scoped>
.register-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background-color: #f0f2f5;
  background-image: url("@/assets/index/bc.jpg");
  background-size: cover;
  background-position: center;
}

.register-box {
  width: 90%;
  max-width: 450px;
  padding: 30px;
  background-color: rgba(255, 255, 255, 0.9);
  border-radius: 8px;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);
}

.register-title {
  margin-bottom: 30px;
  text-align: center;
  color: #333;
  font-size: 24px;
}

.register-form {
  margin-bottom: 20px;
}

.register-btn {
  width: 100%;
  margin-top: 10px;
}

.register-footer {
  display: flex;
  justify-content: center;
  font-size: 14px;
  color: #666;
  text-align: center;
  margin-top: 20px;
}

/* 协议内容样式 */
.agreement-content {
  max-height: 60vh;
  overflow-y: auto;
  padding: 0 10px;
}

.agreement-content h3 {
  color: #409EFF;
  margin: 20px 0 10px;
}

.agreement-content p {
  margin: 8px 0;
  line-height: 1.6;
}

/* 响应式调整 */
@media (max-width: 768px) {
  .register-box {
    width: 85%;
    padding: 20px;
  }

  .register-title {
    font-size: 20px;
    margin-bottom: 20px;
  }

  .agreement-dialog {
    width: 90% !important;
  }
}

@media (max-width: 480px) {
  .register-box {
    width: 90%;
    padding: 15px;
  }

  .register-title {
    font-size: 18px;
  }

  .agreement-content {
    font-size: 14px;
  }
}
</style>